import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { s__ } from "../../../i18n/src";
import { Play } from "../../../play/src";
import { MediaWrapper } from './MediaWrapper';
import { Thumbnail } from './Thumbnail';
import { getAspectRatioForEmbed } from '../utils';
export const VideoMedia = ({ aspectRatio: aspectRatioProp, autoplay, embed, href, onVideoPlay, renderEmptyPreview, }) => {
    const { html, thumbnail_url: thumbnailUrl } = embed;
    const [isPlaying, setIsPlaying] = useState(autoplay);
    const aspectRatio = aspectRatioProp !== null && aspectRatioProp !== void 0 ? aspectRatioProp : getAspectRatioForEmbed(embed);
    const handlePlayVideo = () => {
        if (onVideoPlay) {
            onVideoPlay(embed);
            return;
        }
        setIsPlaying(true);
    };
    if (!thumbnailUrl) {
        return (_jsxs(MediaWrapper, { "$aspectRatio": aspectRatio, bg: "black", children: [_jsx(VideoContent, { dangerouslySetInnerHTML: { __html: html } }), !isPlaying && (_jsx(Glimmer, { children: _jsx(Play, { ariaLabel: s__('Embed|Start the video preview'), onClick: handlePlayVideo }) }))] }));
    }
    if (isPlaying) {
        return (_jsx(MediaWrapper, { "$aspectRatio": aspectRatio, bg: "black", children: _jsx(VideoContent, { dangerouslySetInnerHTML: { __html: html } }) }));
    }
    return (_jsxs(MediaWrapper, { "$aspectRatio": aspectRatio, bg: "black", children: [_jsx(Thumbnail, { aspectRatio: aspectRatio, embed: embed, href: href, renderEmptyPreview: renderEmptyPreview, withLink: false }), _jsx(Glimmer, { children: _jsx(Play, { ariaLabel: s__('Embed|Start the video preview'), onClick: handlePlayVideo }) })] }));
};
const VideoContent = styled(Box) `
  display: block;
  background-color: #000;
  text-align: center;
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }
`;
const Glimmer = styled(Box) `
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
`;
//# sourceMappingURL=VideoMedia.js.map